/**
 * 自由布局的标签页平铺展开
 */
import $ from "jquery"
class TabsTiled {
  constructor(vue) {
    this.context = vue
    this.scrollStepHeight = 0
    this.timer = null
  }
  async init() {
    await this.initData()
    const flag = this.updateLayoutHeight()
    if (flag) this.startAutoScroll()
  }
  async initData() {
    console.log("this.cacheDataTypes", this.context.cacheDataTypes)
    const ids = {
      container_id: this.context.myid.container_id,
      rect_id: this.context.myid.rect_id
    }
    if (!this.context.isBigScreenPreview()) {
      // 非大屏预览模式下，不需要重新生成布局
      this.context.$store.dispatch(this.context.request_prefix + "/changeLayoutBlockByTabs", ids)
    }

    const len = this.context.options.rows.length

    // 遍历rows，找到每个rows中字段映射是tabs的文本组件，将对应分类的lable赋值给文本组件
    for (let i = 0; i < len; i++) {
      const param = {
        ...this.context.myid,
        option_name: "activeIndex",
        option_val: i
      }
      // 这一步很关键，因为changeOptions是通过activeIndex来锁定自由布局的位置
      this.context.$store.dispatch(this.context.request_prefix + "/changeOptions", param)

      let ids = {
        container_id: this.context.myid.container_id,
        rect_id: this.context.myid.rect_id
      }
      const rowOptions = this.context.options.rows[i]
      ids.uid = rowOptions.cols[0].uid
      ids.elementInLayoutId = rowOptions.cols[0].elementOptions.filter(item => {
        return item.innerElement === "cxText" && item.filedMapping && item.filedMapping.value === "tabs"
      })[0]?.elementInLayoutId
      if (typeof ids.elementInLayoutId !== "undefined") {
        let completeparam = Object.assign({}, ids)
        completeparam.option_name = "content"
        completeparam.option_val = this.context.cacheDataTypes[i].label
        this.context.$store.dispatch(this.context.request_prefix + "/changeLayoutOption", completeparam)
      }

      // 需要根据当前自由布局的rows.length去循环请求数据并渲染
      this.context.activeIndex = i
      await this.context.timerUpdate("all")
    }
    // 数据更新完后需要将activeIndex的值还原回去
    const deFaultParam = {
      ...this.context.myid,
      option_name: "activeIndex",
      option_val: 0
    }
    this.context.$store.dispatch(this.context.request_prefix + "/changeOptions", deFaultParam)
    // 需要通知getParentEgineDataPlugin进行后续更新
    this.context.$eventBus.$emit("tabsTiledPlugin:finish", { msg: "fineshed" })
  }
  // 手动判断当前平铺的自由布局是否超出了画布的尺寸，如果超出了，需要手动更改自由布局的可视区域，并且让自由布局的内容自动滚动起来
  updateLayoutHeight() {
    const domStr = this.context.$event.getIdsByStrId(this.context.myid)
    const containerDom = $(`.${domStr}`)
    const rectDom = $(`.${domStr} .content_center`)
    // 获取画布尺寸
    const pageHeight = this.context.$store.state[this.context.request_prefix].page.height
    const containerHeight = containerDom.height()
    const nums = rectDom.length
    let onlyShowNums = Math.floor(pageHeight / containerHeight)
    // 如果onlyShowNums>nums，则不需要滚动实现
    if (onlyShowNums > nums) {
      return false
    } else {
      rectDom.css("height", `${containerHeight}px`)
      this.scrollStepHeight = containerHeight
      containerDom.css("height", `${containerHeight * onlyShowNums}px`)
      containerDom.css("overflow", "hidden")
      return true
    }
  }
  // 开始自动滚动
  startAutoScroll() {
    const domStr = this.context.$event.getIdsByStrId(this.context.myid)
    let self = this
    function play() {
      self.timer = setInterval(function () {
        $(`.${domStr} .bv-example-row`).css("position", "absolute")
        $(`.${domStr} .bv-example-row`).animate(
          {
            top: `-${self.scrollStepHeight}px`
          },
          function () {
            $(this).append($(`.${domStr} .content_center:first`))
            $(this).css("top", "0")
          }
        )
      }, 10000)
    }
    play()
    // 鼠标移入的时候停止自动滚动
    $(`.${domStr} .bv-example-row`).mouseenter(function () {
      clearInterval(self.timer)
      self.timer = null
    })
    // 鼠标移出时继续滚动
    $(`.${domStr} .bv-example-row`).mouseleave(function () {
      play()
    })
  }
}

export default {
  methods: {
    tabsTiledPlugin() {
      new TabsTiled(this).init()
    }
  }
}
